var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_226_10391)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.283 160.705C228.099 161.251 210.404 199.803 205.686 219.148C202.834 254.074 235.249 261.928 242.751 256.925C246.945 254.129 255.484 250.418 261.639 249.156C267.794 250.418 276.334 254.129 280.528 256.925C288.03 261.928 320.445 254.074 317.593 219.148C312.875 199.803 295.18 161.251 261.996 160.705V160.699C261.877 160.699 261.758 160.7 261.639 160.701C261.521 160.7 261.402 160.699 261.283 160.699V160.705Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.176 285.054L159.861 560H366.595L346.131 269.313C370.478 228.596 369.218 176.79 365.545 155.977C358.829 117.358 337.911 117.498 328.291 122.396C327.452 92.1725 316.746 87.2402 300.482 82.5179C276.868 79.3696 264.625 94.2362 260.078 104.031C260.078 93.0119 250.108 83.9732 242.762 82.5179C198.267 73.7029 190.294 105.43 189.769 122.396C180.954 117.778 167.05 122.815 160.384 128.692C120.506 163.847 154.614 259.868 177.176 285.054Z",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.273,
    cy: 160.699,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 332.487,
    cy: 160.699,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.496,
    cy: 119.772,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.61,
    cy: 119.772,
    rx: 14.6918,
    ry: 16.7906,
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.53 471.38C190.842 452.581 170.286 463.547 162.844 471.38L155 572H282.921C291.128 518.978 273.066 505.723 263.009 505.723C249.01 503.795 224.19 482.024 213.53 471.38Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.686 339.441C230.216 296.629 195.134 281.309 176.527 279L169 390.438C171.509 400.511 184.262 394.635 190.325 390.438C213.908 381.875 221.059 352.872 221.686 339.441Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.372 351.706C301.181 335.939 317.254 345.136 323.815 351.706C342.02 358.315 343.496 381.885 338.576 389.892C317.664 408.985 321.559 423.151 317.664 436.085C305.363 464.416 296.752 470.575 289.372 469.959C283.467 469.467 268.05 447.171 261.079 436.085C238.323 397.283 264.77 380.037 270.92 376.342C275.841 373.386 285.271 358.686 289.372 351.706Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.418 108.755L152.869 125.365C153.212 126.645 154.683 127.244 155.822 126.567L166.279 120.356C167.529 119.614 167.595 117.828 166.402 116.996L151.494 106.597C149.964 105.529 147.935 106.953 148.418 108.755Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.298 109.015L358.056 125.021C357.861 126.414 356.327 127.176 355.099 126.489L344.712 120.683C343.476 119.992 343.33 118.271 344.431 117.382L357.061 107.182C358.472 106.042 360.55 107.219 360.298 109.015Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.301 65.4317L314.852 81.5845C314.9 82.9901 313.52 84.0048 312.193 83.5405L300.96 79.6123C299.623 79.1449 299.182 77.4747 300.114 76.4084L310.796 64.1838C311.99 62.8178 314.239 63.6187 314.301 65.4317Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.655 61.7614L216.94 77.2205C216.529 78.5657 217.599 79.9031 219.002 79.7985L230.868 78.9135C232.28 78.8082 233.139 77.3091 232.515 76.038L225.364 61.4639C224.564 59.8354 222.184 60.0264 221.655 61.7614Z",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.099 476.889L420.574 417.364",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.538,
    cy: 326.588,
    r: 107.084,
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.408 377.507C343.655 379.16 349.664 385.604 352.701 390.375C352.854 390.615 352.99 390.865 353.109 391.124C357.596 400.936 366.656 402.056 370.3 401.506C373.679 400.996 376.832 403.322 377.342 406.701C377.853 410.08 375.527 413.233 372.148 413.744C365.021 414.82 349.628 412.708 342.054 396.703C339.851 393.385 336.388 390.326 332.975 389.642C330.429 389.131 325.668 389.534 319.508 398.83C317.62 401.679 313.78 402.458 310.932 400.57C308.083 398.682 307.303 394.843 309.191 391.994C316.995 380.217 326.186 375.658 335.408 377.507Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.252 305.09C411.17 300.62 409.662 293.838 409.475 289.52C409.463 289.235 409.47 288.95 409.497 288.667C410.144 281.855 405.558 278.432 403.524 277.634C400.342 276.387 398.774 272.796 400.022 269.614C401.27 266.432 404.86 264.864 408.042 266.112C413.352 268.194 422.921 275.636 421.86 289.343C422.047 291.966 423.027 294.567 424.426 295.797C425.142 296.427 427.473 298.092 434.357 294.664C437.416 293.141 441.131 294.386 442.654 297.445C444.178 300.504 442.933 304.219 439.873 305.743C430.325 310.497 422.08 310.216 416.252 305.09Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.227 239.668C341.674 239.668 346.9 243.769 346.9 248.828L346.9 261.041C346.9 266.099 341.674 270.2 335.227 270.2C328.779 270.2 323.553 266.099 323.553 261.041L323.553 248.828C323.553 243.769 328.779 239.668 335.227 239.668Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.227 333.059C341.674 333.059 346.9 337.642 346.9 343.296L346.9 356.946C346.9 362.599 341.674 367.183 335.227 367.183C328.779 367.183 323.553 362.599 323.553 356.946L323.553 343.296C323.553 337.642 328.779 333.059 335.227 333.059Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.949 257.504C383.876 261.431 383.876 267.798 379.949 271.725L370.468 281.206C366.541 285.133 360.173 285.133 356.246 281.206C352.319 277.279 352.319 270.912 356.246 266.985L365.727 257.504C369.654 253.577 376.021 253.577 379.949 257.504Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.634 324.815C316.561 328.742 316.561 335.109 312.634 339.036L303.153 348.517C299.226 352.444 292.859 352.444 288.932 348.517C285.005 344.59 285.005 338.223 288.932 334.296L298.413 324.815C302.34 320.888 308.707 320.888 312.634 324.815Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.302 257.503C293.229 253.575 299.596 253.575 303.523 257.503L313.004 266.984C316.931 270.911 316.931 277.278 313.004 281.205C309.077 285.132 302.71 285.132 298.783 281.205L289.302 271.724C285.375 267.797 285.375 261.43 289.302 257.503Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.616 324.814C360.543 320.887 366.91 320.887 370.837 324.814L380.318 334.295C384.245 338.222 384.245 344.589 380.318 348.516C376.391 352.443 370.024 352.443 366.096 348.516L356.616 339.035C352.688 335.108 352.688 328.741 356.616 324.814Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.469 301.633C271.469 296.177 275.57 291.755 280.628 291.755L292.841 291.755C297.899 291.755 302 296.177 302 301.633C302 307.088 297.899 311.511 292.841 311.511L280.628 311.511C275.57 311.511 271.469 307.088 271.469 301.633Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.859 301.633C364.859 296.177 369.443 291.755 375.096 291.755L388.746 291.755C394.4 291.755 398.983 296.177 398.983 301.633C398.983 307.088 394.4 311.511 388.746 311.511L375.096 311.511C369.443 311.511 364.859 307.088 364.859 301.633Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.635 302.531C375.635 325.344 357.141 343.838 334.328 343.838C311.514 343.838 293.021 325.344 293.021 302.531C293.021 279.717 311.514 261.223 334.328 261.223C357.141 261.223 375.635 279.717 375.635 302.531Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.479 289.53C356.479 296.302 350.99 301.791 344.218 301.791C337.446 301.791 331.957 296.302 331.957 289.53C331.957 282.758 337.446 277.269 344.218 277.269C350.99 277.269 356.479 282.758 356.479 289.53Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.322 315.687C330.322 320.653 326.296 324.679 321.33 324.679C316.364 324.679 312.339 320.653 312.339 315.687C312.339 310.721 316.364 306.696 321.33 306.696C326.296 306.696 330.322 310.721 330.322 315.687Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.9 329.907C446.9 335.376 442.745 339.808 437.618 339.808C432.492 339.808 428.336 335.376 428.336 329.907C428.336 324.439 432.492 320.006 437.618 320.006C442.745 320.006 446.9 324.439 446.9 329.907Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.207 242.655C391.207 246.414 388.159 249.462 384.4 249.462C380.64 249.462 377.593 246.414 377.593 242.655C377.593 238.896 380.64 235.848 384.4 235.848C388.159 235.848 391.207 238.896 391.207 242.655Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.487 335.113C413.774 335.113 416.439 337.204 416.439 339.783L416.439 346.009C416.439 348.589 413.774 350.679 410.487 350.679C407.2 350.679 404.535 348.589 404.535 346.009L404.535 339.783C404.535 337.204 407.2 335.113 410.487 335.113Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.487 382.729C413.774 382.729 416.439 385.066 416.439 387.948L416.439 394.908C416.439 397.79 413.774 400.127 410.487 400.127C407.2 400.127 404.535 397.79 404.535 394.908L404.535 387.948C404.535 385.066 407.2 382.729 410.487 382.729Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.289 344.205C435.292 346.207 435.292 349.454 433.289 351.456L428.456 356.29C426.453 358.292 423.207 358.292 421.205 356.29C419.203 354.287 419.203 351.041 421.205 349.039L426.039 344.205C428.041 342.203 431.287 342.203 433.289 344.205Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.969 378.526C400.971 380.529 400.971 383.775 398.969 385.777L394.135 390.611C392.133 392.613 388.887 392.613 386.885 390.611C384.882 388.609 384.882 385.362 386.885 383.36L391.718 378.526C393.721 376.524 396.967 376.524 398.969 378.526Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.073 344.205C389.075 342.203 392.321 342.203 394.323 344.205L399.157 349.039C401.16 351.041 401.16 354.288 399.157 356.29C397.155 358.292 393.909 358.292 391.907 356.29L387.073 351.456C385.07 349.454 385.07 346.207 387.073 344.205Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.392 378.525C423.394 376.523 426.641 376.523 428.643 378.525L433.477 383.359C435.479 385.362 435.479 388.608 433.477 390.61C431.474 392.612 428.228 392.612 426.226 390.61L421.392 385.776C419.39 383.774 419.39 380.528 421.392 378.525Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.98 366.705C377.98 363.924 380.071 361.669 382.65 361.669H388.877C391.456 361.669 393.547 363.924 393.547 366.705C393.547 369.486 391.456 371.741 388.877 371.741H382.65C380.071 371.741 377.98 369.486 377.98 366.705Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.596 366.705C425.596 363.924 427.932 361.669 430.815 361.669L437.774 361.669C440.657 361.669 442.994 363.924 442.994 366.705C442.994 369.486 440.657 371.741 437.774 371.741L430.815 371.741C427.932 371.741 425.596 369.486 425.596 366.705Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.09 367.162C431.09 378.794 421.661 388.223 410.029 388.223C398.398 388.223 388.969 378.794 388.969 367.162C388.969 355.531 398.398 346.102 410.029 346.102C421.661 346.102 431.09 355.531 431.09 367.162Z",
    fill: "#1C1B1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.245 361.01C422.245 364.618 419.32 367.542 415.713 367.542C412.105 367.542 409.181 364.618 409.181 361.01C409.181 357.403 412.105 354.478 415.713 354.478C419.32 354.478 422.245 357.403 422.245 361.01Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.31 374.946C408.31 377.592 406.165 379.736 403.52 379.736C400.874 379.736 398.729 377.592 398.729 374.946C398.729 372.3 400.874 370.156 403.52 370.156C406.165 370.156 408.31 372.3 408.31 374.946Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_226_10391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/피부과_진드기.afba43bebfed51b07f3ae5d32e96a453.svg";
export { ForwardRef as ReactComponent };